export default {
  name: 'SecurityMixin',
  methods: {
    isFirebaseInitialized: function() {
      // Returns boolean
      // We know we are initialized if we have a copy of the app in the store state
      return null != this.$store.state.firebaseApp
    },
    startFirebase: function() {
      // Call this to initialize Firebase
      // It will first check to see if it is already initialized
      // Returns a promise with a boolean
      if (this.isFirebaseInitialized()) {
        return new Promise(function(resolve, reject) {
          resolve(true)
        })
      }
      // We must initialize
      return new Promise(
        function(resolve, reject) {
          var app = this.$firebase.initializeApp(
            this.$store.state.constants.FIREBASE_PROJECT
          )
          if (null != app) {
            this.$store.commit('setFirebaseApp', app)
            resolve(true)
          } else {
            reject(new Error('Error with firebase.initializeApp!'))
          }
        }.bind(this)
      )
    },
    isUserAlreadyLoggedIn: function() {
      // Returns boolean
      return null != this.$store.state.user
    },
    saveUserLoginResults: function(user) {
      // This might be called if auto login is successful
      // console.log('User Login Successful! ', user)
      this.$store.commit('setUser', user.toJSON())
      return true
    },
    saveLoginResults: function(results) {
      // Returns a boolean indicating success or not
      // Pull out the user object
      // console.log('Results from startFirebase:', results)
      return this.saveUserLoginResults(results.user)
    },
    autoLogin: function() {
      // Returns a promise
      return new Promise(
        function(resolve, reject) {
          this.startFirebase().then(
            function(result) {
              this.$firebase.auth().onAuthStateChanged(
                function(user) {
                  if (user) {
                    // User is signed in.
                    // console.log('autoLogin:', user)
                    var result = this.saveUserLoginResults(user)
                    resolve(true)
                  } else {
                    // No user is signed in.
                    console.error('autoLoginFailed!!')
                    // reject(new Error({'Auto Login Failed. User not logged in.': false}))
                    resolve(false)
                  }
                }.bind(this)
              )
            }.bind(this)
          )
          // .catch (error) {
          //   console.log('Start Firebase Error:', error)
          // }
        }.bind(this)
      )
    },
    logIn: function(email, password) {
      // Returns a promise
      return this.startFirebase().then(
        function(result) {
          // Return the promise
          // console.log('Persistance State: ', this.$firebase.auth.Auth.Persistence.LOCAL)
          return this.$firebase
            .auth()
            .setPersistence(this.$firebase.auth.Auth.Persistence.LOCAL)
            .then(
              function() {
                return this.$firebase
                  .auth()
                  .signInWithEmailAndPassword(email, password)
              }.bind(this)
            )
            .then(this.saveLoginResults)
        }.bind(this)
      )
    },
    logOut: function() {
      // Returns a promise
      // Clear out the localstorage data for the user
      console.log('Performing Firebase signOut...')
      return this.$store.state.firebaseApp.signOut()
    }
  }
} // End of Security Mixin
